export default {
  'goldkid-stepperAB:title': 'Как открыть Kaspi&nbsp;Gold&nbsp;для&nbsp;ребенка?',
  'goldkid-stepperAB:step-1': 'Введите ИИН ребенка',
  'goldkid-stepperAB:step-1-noIin': 'Нет ИИН ребенка?',
  'goldkid-stepperAB:step-2': 'Вы подтверждаете номер телефона ребенка с помощью SMS-кода',
  'goldkid-stepperAB:step-2-desc': 'Мы отправим SMS-код на номер вашего ребенка',
  'goldkid-stepperAB:step-3': 'Ребенок устанавливает себе приложение Kaspi.kz и проходит <br/> регистрацию со своего номера',
  'goldkid-stepperAB:step-4': 'Вы подтверждаете регистрацию ребенка с помощью Kaspi QR'
}
